(function () {
  if (window.QotCustomizeBox) return;
  window.QotCustomizeBox = true;

  var TTL = 400 * 24 * 60 * 60 * 1000;

  function init() {
    document.querySelectorAll("[data-customize-box]").forEach(setup);
  }

  function setup(box) {
    var form = box.closest("form");
    if (!form || form.getAttribute("data-customize-ready") === "true") return;
    form.setAttribute("data-customize-ready", "true");

    var productId = box.getAttribute("data-product-id");
    var storageKey = "qot_cz_" + productId;
    var params = new URLSearchParams(window.location.search);
    var czKey = params.get("cz_key");

    function fields() {
      return Array.prototype.slice.call(box.querySelectorAll("[data-customize-input]"));
    }

    function hiddenFor(input) {
      return box.querySelector('[data-customize-hidden="' + input.getAttribute("data-customize-key") + '"]');
    }

    function sync(input) {
      var hidden = hiddenFor(input);
      if (hidden) hidden.value = input.value;
    }

    function readValues() {
      var values = {};
      fields().forEach(function (input) {
        values[input.getAttribute("data-customize-label")] = input.value;
      });
      return values;
    }

    function writeValues(map) {
      if (!map) return;
      fields().forEach(function (input) {
        var label = input.getAttribute("data-customize-label");
        if (Object.prototype.hasOwnProperty.call(map, label)) {
          input.value = map[label];
          sync(input);
        }
      });
    }

    function save() {
      try {
        localStorage.setItem(storageKey, JSON.stringify({
          savedAt: Date.now(),
          fields: readValues()
        }));
      } catch (e) {}
    }

    function loadSaved() {
      try {
        var raw = localStorage.getItem(storageKey);
        if (!raw) return null;
        var data = JSON.parse(raw);
        if (!data || !data.savedAt || !data.fields) return null;
        if (Date.now() - data.savedAt > TTL) return null;
        return data.fields;
      } catch (e) {
        return null;
      }
    }

    function trimFields() {
      fields().forEach(function (input) {
        input.value = input.value.replace(/^\s+|\s+$/g, "");
        sync(input);
      });
    }

    function propertiesPayload() {
      var props = {};
      fields().forEach(function (input) {
        props[input.getAttribute("data-customize-label")] = input.value;
        props["_" + input.getAttribute("data-customize-key")] = input.value;
      });
      return props;
    }

    function quantity() {
      var qtyInput = form.querySelector('input[name="quantity"]');
      var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
      return qty > 0 ? qty : 1;
    }

    function selectedVariant() {
      var idInput = form.querySelector('[name="id"]');
      return idInput ? String(idInput.value) : "";
    }

    function showFieldErrors() {
      var invalid = null;
      fields().forEach(function (input) {
        var error = input.parentNode.querySelector(".customize-box__error");
        if (!input.value) {
          if (!invalid) invalid = input;
          input.setAttribute("aria-invalid", "true");
          if (error) error.hidden = false;
        } else {
          input.removeAttribute("aria-invalid");
          if (error) error.hidden = true;
        }
      });
      return invalid;
    }

    function markEditing(line) {
      form.setAttribute("data-customize-editing", line.key);
      form.setAttribute("data-customize-variant", String(line.id));
      var text = form.querySelector(".add_to_cart .text");
      var label = box.getAttribute("data-update-label");
      if (text && label) text.textContent = label;
    }

    fields().forEach(function (input) {
      input.addEventListener("input", function () {
        sync(input);
        save();
      });
    });

    if (czKey) {
      fetch("/cart.js", { credentials: "same-origin" })
        .then(function (response) { return response.json(); })
        .then(function (cart) {
          var line = (cart.items || []).filter(function (item) { return item.key === czKey; })[0];
          if (line && line.properties) {
            writeValues(line.properties);
            save();
            markEditing(line);
          } else {
            writeValues(loadSaved());
          }
        })
        .catch(function () {
          writeValues(loadSaved());
        });
    } else {
      writeValues(loadSaved());
    }

    form.addEventListener("submit", function (event) {
      trimFields();
      var invalid = showFieldErrors();
      if (invalid) {
        event.preventDefault();
        event.stopPropagation();
        invalid.focus();
        return;
      }
      save();

      var editing = form.getAttribute("data-customize-editing");
      if (!editing) return;

      event.preventDefault();
      event.stopPropagation();
      var button = form.querySelector(".add_to_cart");
      if (button) button.disabled = true;
      var formError = box.querySelector("[data-customize-form-error]");
      if (formError) formError.hidden = true;

      var sameVariant = form.getAttribute("data-customize-variant") === selectedVariant();
      var request = sameVariant
        ? changeLine(editing, propertiesPayload(), quantity())
        : replaceLine(editing, selectedVariant(), quantity(), propertiesPayload());

      request.then(function () {
        window.location.href = "/cart";
      }).catch(function () {
        if (button) button.disabled = false;
        if (formError) formError.hidden = false;
      });
    }, true);
  }

  function postJson(url, body) {
    return fetch(url, {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify(body)
    }).then(function (response) {
      if (!response.ok) throw new Error("cart request failed");
      return response.json();
    });
  }

  function changeLine(id, properties, quantity) {
    return postJson("/cart/change.js", { id: id, quantity: quantity, properties: properties });
  }

  function replaceLine(oldId, variantId, quantity, properties) {
    return postJson("/cart/change.js", { id: oldId, quantity: 0 }).then(function () {
      return postJson("/cart/add.js", {
        id: Number(variantId),
        quantity: quantity,
        properties: properties
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
